import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { AYEN_SERVICES_ENDPOINTS } from '../../api/endpoints/ayen-services.endpoints';
import { SKIP_ERROR_HANDLER } from '../../http-context-token';
import { HttpContext } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AyenServices {
  private api = inject(ApiService);
  private featureFlagsSubject = new BehaviorSubject<any | null>(null);
  
  // Expose as observable for reactive components
  public readonly featureFlags$ = this.featureFlagsSubject.asObservable();

  getAyenServices(): Observable<any> {
    return this.api.get(AYEN_SERVICES_ENDPOINTS.V1.AYEN_SERVICES);
  }

  getFeatureFlags(): Observable<any> {
    if (this.featureFlagsSubject.value !== null) {
      return of(this.featureFlagsSubject.value);
    }
    return this.api.get<any>(AYEN_SERVICES_ENDPOINTS.V1.FEATURE_FLAGS,  {
        context: new HttpContext().set(SKIP_ERROR_HANDLER, true)
    }).pipe(
      tap(data => this.featureFlagsSubject.next(data)),
      catchError(error => {
        this.featureFlagsSubject.next(null);
        return throwError(() => error);
      })
    );
  }

  /**
   * Check if a specific feature flag is enabled
   * @param key - The feature flag key to check
   * @returns true if the flag exists and is enabled, false otherwise
   */
  isFeatureEnabled(key: string): boolean {
    const flags = this.featureFlagsSubject.value;
    if (!flags || !Array.isArray(flags)) return false;
    const flag = flags.find(item => item.key === key);
    return flag?.is_enabled === true;
  }
}
